var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosetSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10V7.90738L13.3823 7.13938C14.0722 6.75618 14.5 6.02911 14.5 5.24C14.4183 3.92771 13.2929 2.92731 11.9801 3C10.807 2.95132 9.76537 3.74427 9.5 4.88793",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16.5H17C17.5523 16.5 18 16.9477 18 17.5V21H6V17.5C6 16.9477 6.44772 16.5 7 16.5Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 18H19.2388C20.0156 18.0039 20.7018 17.4949 20.9236 16.7504C21.1453 16.006 20.8493 15.2044 20.197 14.7827L13.4785 10.4362C12.5788 9.8546 11.4216 9.8546 10.5218 10.4362L3.8034 14.7827C3.15104 15.2044 2.85507 16.006 3.0768 16.7504C3.29853 17.4949 3.9848 18.0039 4.7616 18H6.00018",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosetSpace);
export default __webpack_public_path__ + "static/media/closetSpace.ca5df9b125558165f6dff7d22f8345f4.svg";
export { ForwardRef as ReactComponent };